<c-container class="dashboard-container" fluid>
  <c-row class="mb-4">
    <c-col xs="12">
      <h2 class="mb-5">
        {{ 'dashboard_welcome' | translate: { appName: (domainName() || 'FAC3LESS') } }}!
      </h2>
    </c-col>
  </c-row>

  <!-- eWallet balances per currency -->
  @if (balances().length > 0) {
    <c-row class="mb-4">
      <c-col xs="12">
        <c-card class="dashboard-card">
          <c-card-body>
            <h3 cCardTitle class="mb-3">{{ 'dashboard_balances_title' | translate }}</h3>
            <c-row>
              @for (b of balances(); track b.currency) {
                <c-col xs="6" md="4" lg="3" class="mb-3">
                  <div class="balance-tile p-3 border rounded h-100">
                    <div class="text-body-secondary small text-uppercase">{{ b.currency }}</div>
                    <div class="fs-4 fw-bold text-primary">{{ b.balance | currencyAmount: b.currency }}</div>
                  </div>
                </c-col>
              }
            </c-row>
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
  }

  <!-- Latest Info Media -->
  @if (media(); as m) {
    <c-row class="mb-4">
      <c-col>
        <media-card [media]="m" (click)="openMediaViewer(m)"></media-card>
      </c-col>
    </c-row>
    <c-row [routerLink]="['/', currentLang(), 'media', 'info']" class="mb-4">
      <c-col>
        <c-alert class="info">
          <svg cIcon name="info" class="me-2"></svg>
          <span [translate]="'menu.info'"></span>
        </c-alert>
      </c-col>
    </c-row>
  }

  <!-- Quick Action Cards -->
  <c-row>
    <c-col xs="12" md="6" lg="4" class="mb-4">
      <c-card class="dashboard-card h-100">
        <c-card-body class="d-flex flex-column">
          <div class="card-icon mb-3">
            <svg cIcon name="cilCart" size="lg"></svg>
          </div>
          <h3 cCardTitle>{{ 'dashboard_order_products_title' | translate }}</h3>
          <p cCardText class="flex-grow-1">
            {{ 'dashboard_order_products_description' | translate }}
          </p>
          <button
            cButton
            color="primary"
            size="lg"
            class="w-100"
            routerLink="/{{ currentLang() }}/order-wizard"
          >
            <svg cIcon name="cilCart" class="me-2"></svg>
            {{ 'dashboard_start_order' | translate }}
          </button>
        </c-card-body>
      </c-card>
    </c-col>

    <c-col xs="12" md="6" lg="4" class="mb-4">
      <c-card class="dashboard-card h-100">
        <c-card-body class="d-flex flex-column">
          <div class="card-icon mb-3">
            <svg cIcon name="cilUser" size="lg"></svg>
          </div>
          <h3 cCardTitle>{{ 'dashboard_my_profile_title' | translate }}</h3>
          <p cCardText class="flex-grow-1">
            {{ 'dashboard_my_profile_description' | translate }}
          </p>
          <button
            cButton
            color="success"
            variant="outline"
            size="lg"
            class="w-100"
            routerLink="/{{ currentLang() }}/profile"
          >
            <svg cIcon name="cilUser" class="me-2"></svg>
            {{ 'dashboard_view_profile' | translate }}
          </button>
        </c-card-body>
      </c-card>
    </c-col>

    <c-col xs="12" md="6" lg="4" class="mb-4">
      <c-card class="dashboard-card h-100">
        <c-card-body class="d-flex flex-column">
          <div class="card-icon mb-3">
            <svg cIcon name="cilFile" size="lg"></svg>
          </div>
          <h3 cCardTitle>{{ 'dashboard_my_orders_title' | translate }}</h3>
          <p cCardText class="flex-grow-1">
            {{ 'dashboard_my_orders_description' | translate }}
          </p>
          <button
            cButton
            color="primary"
            variant="outline"
            size="lg"
            class="w-100"
            routerLink="/{{ currentLang() }}/my-orders"
          >
            <svg cIcon name="cilFile" class="me-2"></svg>
            {{ 'dashboard_view_orders' | translate }}
          </button>
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>

  <!-- User Cards Table (Meine Karten) -->
  <c-row class="mb-4">
    <c-col xs="12">
      <c-card>
        <c-card-header>
          <strong>{{ 'dashboard_my_cards_title' | translate }}</strong>
        </c-card-header>
        <c-card-body>
          @if (cardsLoading()) {
            <div class="text-center py-4">
              <c-spinner color="primary"></c-spinner>
              <p class="mt-2">{{ 'dashboard_cards_loading' | translate }}</p>
            </div>
          }
          @if (!cardsLoading() && userCards().length === 0) {
            <div class="alert alert-secondary">
              {{ 'dashboard_no_cards' | translate }}
            </div>
          }
          @if (!cardsLoading() && userCards().length > 0) {
            <div class="table-responsive">
              <table cTable striped hover>
                <thead>
                  <tr>
                    <th>{{ 'dashboard_card_number' | translate }}</th>
                    <th>{{ 'dashboard_card_type' | translate }}</th>
                    <th class="text-end">{{ 'dashboard_card_balance' | translate }}</th>
                    <th class="text-end">{{ 'dashboard_card_turnover' | translate }}</th>
                    <th>{{ 'dashboard_card_created' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  @for (card of userCards(); track card.id) {
                    <tr>
                      <td>
                        <span class="badge bg-dark">
                          #{{ card.card_number }}
                        </span>
                      </td>
                      <td>
                        <span class="badge" [ngClass]="'bg-' + getCardTypeBadgeColor(card.card_type)">
                          {{ getCardTypeLabel(card.card_type) }}
                        </span>
                      </td>
                      <td class="text-end">{{ formatCurrency(card.balance) }}</td>
                      <td class="text-end">{{ formatCurrency(card.turnover) }}</td>
                      <td>{{ formatDate(card.created_at) }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>
</c-container>

<!-- PDF Modal (commented out in original - kept as is) -->
<!--
<c-modal
  #pdfModal
  [visible]="pdfModalVisible()"
  (visibleChange)="pdfModalVisible.set($event)"
  size="xl"
  [backdrop]="true"
  class="pdf-modal-fullwidth"
>
  <c-modal-header>
    <h5 cModalTitle>{{ pdfModalTitle() }}</h5>
    <button cButtonClose (click)="pdfModalVisible.set(false)"></button>
  </c-modal-header>
  <c-modal-body class="pdf-modal-body">
    @if (pdfUrl(); as url) {
      <iframe [src]="url" class="pdf-viewer" frameborder="0"></iframe>
    }
  </c-modal-body>
</c-modal>
-->